<template>
    <v-row>

            <v-col cols="12" lg="8" order="12" order-lg="1" v-if="ordersStore.orderData != null">

                <v-card>
                    <v-card-text>
                        <v-container>
                            <PortofolioSteps class="hidden-md-and-down" :current-step="4"></PortofolioSteps>
                            <v-card-title class="pb-2">Folio de transacción: {{order.folio}}</v-card-title>

                            <v-divider></v-divider>

                            <div class="d-flex flex-row-reverse mt-4">
                                <v-btn
                                    color="success"
                                    class="justify-end"
                                    v-if="['pagado', 'referenciado'].includes(order.estatus)"
                                    :href="order.payment_data.url_recibo"
                                    target="_blank"
                                >
                                    <v-icon small class="mr-2" left>fas fa-print</v-icon>
                                    {{ order.estatus === 'pagado' ? 'Resumen de transacción' : 'Formato de Pago' }}
                                </v-btn>
                            </div>

                            <v-divider class="my-4 hidden-lg-and-up"></v-divider>

                            <v-card
                                v-for="(procedureGroup, indexGroup) in proceduresGroup"
                                :key="'procedure'+indexGroup"
                                class="mb-2 mt-2 hidden-lg-and-up"
                            >
                                <v-list two-line>
                                    <template v-for="(procedure, index) in procedureGroup.tramitesCarrito" >
                                        <v-divider
                                            v-if="index > 0"
                                            class="mx-4"
                                            :key="'divider'+procedure.id"
                                        />
                                        <v-list-item :key="'subprocedure'+procedure.id">
                                            <!--<div class="d-flex">-->
                                            <v-list-item-content class="flex-grow-1 flex-shrink-1" style="flex: none;">
                                                <v-list-item-title class="text-h6">
                                                    {{procedure.nombre_tramite}}
                                                </v-list-item-title>
                                                <v-list-item-title class="text-h6 my-1">
                                                    {{ procedure.precio| currency}}
                                                    <span
                                                        v-if="index === 0"
                                                        class="ml-4 text-subtitle-2"
                                                    >
                                                        Trámite:  {{procedure.tramite_id}}
                                                    </span>
                                                </v-list-item-title>
                                                <v-list-item-content class="py-0 pt-2">
                                                    <div class="d-flex mr-2" >
                                                        <div
                                                            v-if="order.estatus === 'pagado'"
                                                            class="mr-4 text-center"
                                                        >
                                                            <v-btn
                                                                x-small color="success" fab
                                                                :href="`${order.payment_data.url_recibo_base}?tramite=${procedure.folio_pago}`"
                                                                target="_blank"
                                                            >
                                                                <v-icon small >fas fa-download</v-icon>
                                                            </v-btn>
                                                            <div class="mt-1 text-subtitle-2 ">Recibo</div>
                                                        </div>
                                                        <template v-if="order.estatus === 'pagado' && procedure.datos_factura_id != null && procedure.datos_factura_id > 0">
                                                            <div class="mx-4 text-center">
                                                                <v-btn
                                                                    x-small color="warning lighten-1" fab
                                                                    :href="procedure.pdf" target="_blank"
                                                                >
                                                                    <v-icon small color="white">fas fa-file-pdf</v-icon>
                                                                </v-btn>
                                                                <div class="mt-1 text-subtitle-2">PDF</div>
                                                            </div>
                                                            <div class="mx-4 text-center">
                                                                <v-btn
                                                                    x-small color="warning lighten-1" fab
                                                                    :href="procedure.xml" target="_blank"
                                                                >
                                                                    <v-icon small color="white">fas fa-file-code</v-icon>
                                                                </v-btn>
                                                                <div class="mt-1 text-subtitle-2">XML</div>
                                                            </div>
                                                        </template>
                                                        <div
                                                            v-if="(procedure.datos_factura_id == null || procedure.datos_factura_id == 0) && procedure.facturable == 1 && order.estatus === 'pagado'"
                                                            class="mx-4 text-center"
                                                        >
                                                            <v-btn
                                                                x-small color="primary" fab
                                                                @click="generateInvoiceCall(procedure.id)"
                                                            >
                                                                <v-icon small color="white">fas fa-file-alt</v-icon>
                                                            </v-btn>
                                                            <div class="mt-1 text-subtitle-2">Generar factura</div>
                                                        </div>
                                                    </div>
                                                </v-list-item-content>
                                            </v-list-item-content>
                                            <v-list-item-content
                                                v-if="index === 0 && (['pagado','referenciado'].includes(order.estatus)) && procedureGroup.etapas.length > 0"
                                                style="flex: none; text-align: center"
                                            >
                                                <router-link :to="getActionLink(procedureGroup.etapas)" class="text-decoration-none">
                                                    <div class="mr-2" style="text-align: right">
                                                        <div class="text-center" v-if="procedureGroup.etapas[procedureGroup.etapas.length -1].pendiente > 0">
                                                            <v-btn small color="primary" fab :href="getActionLink(procedureGroup.etapas)">
                                                                <v-icon>mdi mdi-send</v-icon>
                                                            </v-btn>
                                                            <div class="mt-1 text-subtitle-2">Continuar</div>
                                                        </div>
                                                        <div v-else class="text-center">
                                                            <v-btn small color="primary" fab>
                                                                <v-icon>fas fa-eye</v-icon>
                                                            </v-btn>
                                                            <div class="mt-1 text-subtitle-2">Ver trámite</div>
                                                        </div>
                                                    </div>
                                                </router-link>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-list>
                                <v-card-actions class="pa-0" v-if="procedureGroup.totalTramitesCarrito > 5" :key="'action_'+indexGroup">
                                    <v-btn
                                        color="normal"
                                        width="100%"
                                        height="50"
                                        @click="getProcedureDetails(procedureGroup.tramiteCarritoId, indexGroup)"
                                    >
                                        Ver todos los trámites ({{procedureGroup.totalTramitesCarrito}} elementos)
                                    </v-btn>
                                </v-card-actions>
                            </v-card>

                            <v-simple-table class="mb-2 mt-2 hidden-md-and-down">
                                <thead>
                                <tr>
                                    <th class="text-family text-uppercase">ID</th>
                                    <th class="text-family text-uppercase">Trámite</th>
                                    <th class="text-family text-uppercase">Precio</th>
                                    <th class="text-family text-uppercase">Acción</th>
                                    <th class="text-family text-uppercase">Recibo</th>
                                    <th class="text-family text-uppercase">Factura</th>
                                </tr>
                                </thead>

                                <tbody>
                                <template v-for="(procedureGroup, indexGroup) in proceduresGroup">
                                    <template
                                        v-for="(procedure, index) in procedureGroup.tramitesCarrito"
                                    >
                                        <tr :key="procedure.id">
                                            <td class="px-1 text-family">
                                                <template v-if="index === 0">{{ procedure.tramite_id }}</template>
                                            </td>

                                            <!-- NOMBRE DEL TRAMITE -->
                                            <td class="px-1 text-family">
                                                {{procedure.nombre_tramite}}
                                            </td>

                                            <!-- PRECIO -->
                                            <td class="px-1 text-family">
                                                {{procedure.precio | currency}}
                                            </td>

                                            <!-- ACTION DEL TRAMITE -->
                                            <td class="px-1 text-family">
                                                <template
                                                    v-if="index === 0 && (['pagado','referenciado'].includes(order.estatus)) && procedureGroup.etapas.length > 0"
                                                >
                                                    <router-link :to="getActionLink(procedureGroup.etapas)">
                                                        <template v-if="procedureGroup.etapas[procedureGroup.etapas.length -1].pendiente > 0">
                                                            <v-btn
                                                                small color="primary"
                                                            >
                                                                <span class="hidden-md-and-down text-family">Continuar Trámite</span>
                                                                <v-icon small class="hidden-lg-and-up">fas fa-paper-plane</v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <template v-else>
                                                            <v-btn small color="primary">
                                                                <span class="hidden-md-and-down text-family">Ver Trámite</span>
                                                                <v-icon small class="hidden-lg-and-up">fas fa-eye</v-icon>
                                                            </v-btn>
                                                        </template>



                                                    </router-link>
                                                </template>
                                            </td>

                                            <!-- IMPRIMIR RECIBO DE PAGO -->
                                            <td class="px-1 text-family">
                                                <v-btn
                                                    v-if="order.estatus === 'pagado'"
                                                    small color="success"
                                                    :href="`${order.payment_data.url_recibo_base}?tramite=${procedure.folio_pago}`"
                                                    target="_blank"
                                                >
                                                    <v-icon x-small>fas fa-download</v-icon>
                                                    <span class="hidden-md-and-down text-family">Recibo pago </span>
                                                </v-btn>
                                            </td>

                                            <!-- DECARGAR FACTURA PDF/XML -->
                                            <td class="pl-1 text-family">
                                                <template v-if="order.estatus === 'pagado' && procedure.datos_factura_id != null && procedure.datos_factura_id > 0">
                                                    <div class="d-flex">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    small color="warning lighten-1"
                                                                    :href="procedure.pdf" target="_blank"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    class="mr-1"
                                                                >
                                                                    <v-icon small color="white">fas fa-file-pdf</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span class="text-family">Descargar PDF</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    small color="warning lighten-1"
                                                                    :href="procedure.xml" target="_blank"
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                >
                                                                    <v-icon small color="white">fas fa-file-code</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span class="text-family">Descargar XML</span>
                                                        </v-tooltip>
                                                    </div>
                                                </template>
                                                <v-btn
                                                    v-if="(procedure.datos_factura_id == null || procedure.datos_factura_id == 0)
                                    && procedure.facturable == 1 && order.estatus === 'pagado'"
                                                    small color="primary"
                                                    @click="generateInvoiceCall(procedure.id)" class="text-family"
                                                >
                                                    Generar factura
                                                </v-btn>
                                            </td>
                                        </tr>
                                    </template>
                                    <!-- ID -->
                                    <tr v-if="procedureGroup.totalTramitesCarrito > 5" :key="'action_'+indexGroup">
                                        <td colspan="6">
                                            <v-btn
                                                class="text-family"
                                                text color="primary"
                                                width="100%" height="50"
                                                @click="getProcedureDetails(procedureGroup.tramiteCarritoId, indexGroup)"
                                            >
                                                Ver todos los trámites ({{procedureGroup.totalTramitesCarrito}} elementos)
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>

                            </v-simple-table>
                        </v-container>
                    </v-card-text>
                </v-card>

            </v-col>
                <v-col  cols="12" lg="4" order="1" order-lg="12">
                    <Checkout
                        v-if="ordersStore.orderData != null"
                        :checkout-data="ordersStore.orderData.tramitesCheckout"
                        :checkout-total="ordersStore.orderData.checkoutTotal"
                        :checkout-items-number="ordersStore.orderData.tramitesCheckoutItems"
                        :on-show-all-items="getAllCheckoutItems"
                        :on-pay-order="payOrderCall"
                        :on-cancel-order="deleteOrderCall"
                        :order="order"
                    ></Checkout>
                </v-col>

            <!-- PAYMENT HTML RESPONSE TO REDIRECT -->
            <div v-if="ordersStore.paymentResponse != null">
                <div v-html="ordersStore.paymentResponse.content"></div>
            </div>

            <DeleteDialog
                :show-dialog="showDeleteDialog"
                :on-close-dialog="cancelDeleteOrder"
                :on-confirm-delete="confirmDeleteOrder"
            >

            </DeleteDialog>

            <FiscalContact
                v-if="showFiscalContactModal"
                :show-modal="showFiscalContactModal"
                :close-modal="closeFiscalContactModal"
                :selected-fiscal-contact="onSelectedFiscalContact"
                :procedure-contact-default="procedureContactDefault"
            />

            <ErrorModal
                :show-modal="showErrorModal"
                :message-code="errorCodeModal"
                :close-error-modal="closeErrorModal"
            />

    </v-row>
</template>

<script>
import PortofolioSteps from "../Portfolio/PortofolioSteps";
import Checkout from "./Checkout";
import DeleteDialog from "./DeleteDialog";
import FiscalContact from "../Portfolio/Cart2/FiscalContactCfdi";

import {mapState, mapActions, mapGetters} from 'vuex';
import {
    editOrderRequest,
    detailsOrderRequest,
    payOrderRequest,
    cancelOrderRequest,
    generateInvoiceOrderRequest
} from "bestgob-core/api/models";
import ErrorModal from "../Portfolio/Cart2/ErrorModal";
import Vue from 'vue';

export default {
    name: "Edit",

    components: {ErrorModal, PortofolioSteps, Checkout, DeleteDialog, FiscalContact},

    computed: {
        ...mapState({ordersStore: state => state.orders,  alertsStore: state => state.alerts}),
        ...mapGetters('orders', ['order', 'proceduresGroup', 'paymentResponse'])

    },

    data(){
        return {
            showDeleteDialog: false,
            procedureToInvoiceId: 0,

            /** Generate Invoice **/
            showFiscalContactModal: false,
            procedureContactDefault: {
                nombre: '', apellido_pat: '', apellido_mat: ''
            },
            showErrorModal: false,
            errorCodeModal: 1

        }
    },

    watch: {
        '$store.state.orders.paymentResponse'(){
            console.log('here');
            this.$forceUpdate();
            if (this.ordersStore.paymentResponse != null && this.ordersStore.paymentResponse.content && this.ordersStore.paymentResponse.success ){
                var doc = document.implementation.createHTMLDocument(); // Sandbox
                doc.body.innerHTML = this.ordersStore.paymentResponse.content; // Parse HTML properly
                this.$forceUpdate();
                Vue.nextTick(function () {
                    document.getElementById("miaction").submit();
                })
                    
            }
        }

    },

    mounted() {
        this.getOrderContent();
    },

    /*updated() {
        if (this.ordersStore.paymentResponse != null){
            let button = document.getElementById('btn_proceder_pago')
            button.click()
        }
    },*/

    methods: {
        
        
        ...mapActions('orders', [
            'editOrder', 'detailsOrder', 'getCheckoutDetails',
            'payOrder', 'cancelOrder', 'generateInvoiceOrder'
        ]),
        ...mapActions('alerts', ['showLoading']),


        clickedOnPago(){

            setTimeout(() => {
                if(document.getElementById("miaction")){
                    document.getElementById("miaction").submit();
                }else{
                    this.$store.dispatch('alerts/error', 'Ocurrio un error intente nuevamente' , {root: true});
                }

            }, 2500);
        },

        getOrderContent(){
            let request = editOrderRequest()
            request.id = this.$route.params.id

            this.editOrder(request)
        },

        getActionLink(stages){
            if (stages[stages.length - 1].pendiente > 0){
                return {
                    name: 'procedure_continue',
                    params: {stageId: stages[stages.length - 1] ? stages[stages.length - 1].id : 0}
                }
            }else{
                return {
                    name: 'procedure_view',
                    params: {stageId: stages[stages.length - 1] ? stages[stages.length - 1].id : 0}
                }
            }
        },

        getProcedureDetails(procedureGroupId, index){
            let request = detailsOrderRequest()
            request.item_id = procedureGroupId
            request.index = index

            this.detailsOrder(request)
        },

        getAllCheckoutItems(){
            let request = editOrderRequest()
            request.id = this.$route.params.id

            this.getCheckoutDetails(request)
        },

        payOrderCall(){
            let request = payOrderRequest()
            request.id = this.$route.params.id
            request.url_return = this.getPaymentResponseUrl()
            console.log('onPayOrder');
            this.payOrder(request)
        },

        getPaymentResponseUrl(){
            const route = {name: 'orders_details', params: {action:'payment_response', id: this.$route.params.id}}
            //const route = {name: 'orders_details', params: {action:'payment_response', id: 'order_id'}}
            return window.location.origin + this.$router.resolve(route).href
        },

        deleteOrderCall(){
            this.showDeleteDialog = true
        },

        confirmDeleteOrder(action){
            this.showDeleteDialog = false

            let request = cancelOrderRequest()
            request.id = this.order.id
            request.token = this.order.token
            request.accion = action

            this.cancelOrder(request)
        },

        cancelDeleteOrder(){
            this.showDeleteDialog = false
        },

        closeFiscalContactModal(){
            this.showFiscalContactModal = false
        },

        onSelectedFiscalContact(fiscalContact){
            this.showFiscalContactModal = false

            if (fiscalContact.rfc != null && fiscalContact.rfc.length > 10){
                let request = generateInvoiceOrderRequest()
                request.id_tramite_carrito = this.procedureToInvoiceId
                request.datoFiscal = fiscalContact.id

                this.generateInvoiceOrder(request)
            }else{
                this.errorCodeModal = 1
                this.showErrorModal = true
            }
        },

        closeErrorModal(){
            this.showErrorModal = false
        },

        generateInvoiceCall(procedureId){
            this.procedureToInvoiceId = procedureId
            this.showFiscalContactModal = true
        }

    }
}
</script>

<style scoped >
.v-expansion-panel .icon{
    order: 0;
}
.v-expansion-panel .header{
    order: 1;
}

.v-stepper__label{
    color: #FFFFFF !important;
    margin-right: auto !important;
    margin-left: auto !important;
}

.transaction-concepts > * {
    padding: 0px;
}

.transaction-concepts .v-data-table {
    background-color: transparent !important;
}

.v-sheet.v-stepper:not(.v-sheet--outlined){
    box-shadow: none  !important;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

</style>